import { Container } from './MainPage.styles'
import { FirstScreen } from '../../components/FirstScreen'

export const MainPage: React.FC = () => {
  return (
    <Container>
      <FirstScreen />
    </Container>
  )
}
